import { render } from "./SwipeActions.vue?vue&type=template&id=4cbc556c&scoped=true"
import script from "./SwipeActions.vue?vue&type=script&lang=js"
export * from "./SwipeActions.vue?vue&type=script&lang=js"

import "./SwipeActions.vue?vue&type=style&index=0&id=4cbc556c&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbc556c"]])

export default __exports__